/* eslint-disable */
import { isObjEmpty, isStrEmpty } from "@/utils/utils";
import store from "@/store";

export default {
    data(): any {
        return {};
    },

    methods: {
        getTranslatedText(text: string, xargs: any = {}) {
            if (!text) {
                return;
            }
            const language = store.state.lang as Record<string, string>;
            if (!language || Object.keys(language).length === 0) {
                return text;
            }
            const rsText = text.toLowerCase();
            let translatedText: any = text;
            if (!isStrEmpty(language[text])) {
                translatedText = language[text];
            } else if (!isStrEmpty(language[rsText])) {
                translatedText = language[rsText];
            }

            if (!isObjEmpty(xargs)) {
                for (const key in xargs) {
                    translatedText = translatedText.replace(
                        "[" + key + "]",
                        xargs[key]
                    );
                }
            }

            const capitalizedSentence = translatedText.charAt(0).toUpperCase() + translatedText.slice(1)

            return capitalizedSentence;
        },
    },
};
